import { Component, Input, EventEmitter, Output } from '@angular/core';

import { FolderStates } from '@site-mate/dashpivot-shared-library';

import { PhotoModalService } from 'app/photo/photo-modal.service';
import { UserService } from 'app/user/user.service';

@Component({
  selector: 'cc-activity-list',
  templateUrl: 'activity-list.component.html',
  styleUrls: ['activity-list.component.scss'],
})
export class ActivityListComponent {
  isUserAdmin: boolean;

  @Input()
  title;

  @Input()
  activities;

  @Input()
  loading;

  @Input()
  noMoreActivities;

  @Input()
  showTeam;

  @Input()
  showProject;

  @Input() state;

  @Output()
  onLoadMore = new EventEmitter();

  @Output()
  onClickThumbnail = new EventEmitter();

  @Output()
  onClickFormLink = new EventEmitter();

  @Output()
  onClickTemplateLink = new EventEmitter();

  readonly folderStates = FolderStates;

  constructor(private readonly photoModal: PhotoModalService, private readonly userService: UserService) {}

  ngOnInit() {
    this.isUserAdmin = this.userService.isAdmin();
  }

  onViewPhoto({ item, index }) {
    this.photoModal.open({
      timeLineIndex: 0,
      timeLines: [{ photos: item.photos }],
      photoIndex: index,
      hideDeleteButton: true,
      teamId: item.team.id,
      projectId: item.project.id,
    });
    this.onClickThumbnail.emit();
  }

  viewMore() {
    this.onLoadMore.emit();
  }

  checkIfTemplateInDeletedTeam(activity) {
    return activity.team.state === this.folderStates.Deleted && activity.app;
  }

  checkIfTemplateNotInDeletedTeam(activity) {
    return activity.team.state !== this.folderStates.Deleted && activity.app;
  }

  getRouterLinkToAnalyticsDashboard(activity) {
    return [
      '/',
      'analytics',
      activity.team ? 'teams' : 'companies',
      activity.team ? activity.team.id : activity.company.id,
      'dashboards',
      activity.dashboard.id,
      'charts',
      'grid',
    ];
  }

  isDashboardNotDeletedOrInDeletedTeam(activity) {
    return (
      (!activity.team && activity.dashboard) ||
      (activity.dashboard && activity.team.state !== this.folderStates.Deleted)
    );
  }
}
